import React from 'react';
import { NavLink } from 'react-router-dom';

const AddDesignationCrumb = () => <NavLink to="/admin/designations/add">Add Designation</NavLink>;

export default AddDesignationCrumb;
